// 盘库

export default {
  path: "/checkInventory",
  name: "checkInventory",
  meta: { title: "库存盘点", icon: "checkInventoryTil" },
  children: [
    {
      path: "/checkInventory/checkInventoryRecord",
      name: "checkInventoryRecord",
      component: () =>
        import(
          /* webpackChunkName: "checkInventoryRecord" */ "@/views/checkInventory/checkInventoryRecord.vue"
        ),
      meta: { title: "库存盘点", icon: "checkInventoryRecord" },
    },
    {
      path: "/checkInventory/checkInventoryMenu",
      name: "checkInventoryMenu",
      component: () =>
        import(
          /* webpackChunkName: "checkInventoryMenu" */ "@/views/checkInventory/checkInventoryMenu.vue"
        ),
      meta: { title: "盘库记录详情", icon: "user", sidebar: false },
    },
    {
      path: "/checkInventory/approvalCheckInventory",
      name: "approvalCheckInventory",
      component: () =>
        import(
          /* webpackChunkName: "approvalCheckInventory" */ "@/views/checkInventory/approvalCheckInventory.vue"
        ),
      meta: { title: "盘点审批", icon: "approvalCheckInventory" },
    },
  ],
};
